import axios from 'axios';
import http from './http';
import { getAccessToken } from 'utils/sessionStorage';

const notificationServices = {
    // Send email API
    async sendEmail(body: { user_id: number, recipients: Array<{email: string, name: string}>, subject: string, text?: string, senderName: string, senderEmail: string, html?: string, is_draft?: boolean }): Promise<any> {
        const res = await http.post('api/notification/send-email', body);
        return res;
    },

    // Send SMS API  
    async sendSMS(body: { user_id: number, recipients: Array<{phone: string, name: string}>, message: string, is_draft?: boolean }): Promise<any> {
        const res = await http.post('api/notification/send-sms', body);
        return res;
    },

    // Other notification methods
    async createNotification(body: any): Promise<any> {
        const res = await http.post('api/notification', body);
        return res;
    },

    async updateNotification(body: any): Promise<any> {
        const res = await http.put('api/notification', body);
        return res;
    },

    async getNotification(user_id: any) {
        const res = await http.get(`api/notification/${user_id}`);
        return res;
    },

    async getPartnersContactInfo(role: string): Promise<any> {
        const res = await http.get(`api/students/partners-contact-info/${role}`);
        return res;
    },

    async getSendHistory(user_id: any, params?: { send_type?: string, is_draft?: boolean }): Promise<any> {
        let url = `api/notification/send-history/${user_id}`;
        if (params) {
            const queryParams = new URLSearchParams();
            if (params.send_type) {
                queryParams.append('send_type', params.send_type);
            }
            if (params.is_draft !== undefined) {
                queryParams.append('is_draft', params.is_draft.toString());
            }
            if (queryParams.toString()) {
                url += `?${queryParams.toString()}`;
            }
        }
        const res = await http.get(url);
        return res;
    },

    // Delete send history API
    async deleteSendHistory(id: number): Promise<any> {
        const res = await http.delete(`api/notification/send-history/${id}`);
        return res;
    },

    async getConversation(conversation_id: string): Promise<any> {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_API_URL || ''}/api/notification/conversation/${conversation_id}`,
                {
                    headers: {
                        Authorization: `Bearer ${getAccessToken()}`,
                        'Content-Type': 'application/json',
                    },
                    validateStatus: (status) => status === 200 || status === 404,
                }
            );
            if (res.status === 404) return null;
            return res.data;
        } catch {
            return null;
        }
    },

    async sendSMSToConversation(sid: string, message: string): Promise<any> { 
        const res = await http.post(`api/notification/conversation/${sid}/message`, { message });
    return res;

  },
};

export default notificationServices;